import { render, staticRenderFns } from "./semiRank.vue?vue&type=template&id=8b4ad1d0&scoped=true"
import script from "./semiRank.vue?vue&type=script&lang=js"
export * from "./semiRank.vue?vue&type=script&lang=js"
import style0 from "./semiRank.vue?vue&type=style&index=0&id=8b4ad1d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ad1d0",
  null
  
)

export default component.exports